exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.introDonate{\n  display:flex;\n  background: grey;\n  justify-content: space-evenly;\n  padding-top:20px;\n  height: 400px;\n  background-image: url('/assets/images/Donate-Banner.png');\n  background-size: cover;\n}\n.introDescriptionDonate{\n  font-size:30px;\n  color:#22252C; /* #ffffff */\n  padding-top:120px;\n}\n.introDescriptionDonate p{\n  font-size:60px;\n  color:#22252C; /* #ffffff */\n  font-weight: 900;\n}\n", ""]);

// exports
